/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Simple_Youwillreceive2Inputs */

const id_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda akan menerima notifikasi untuk:`)
};

const ms_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda akan menerima pemberitahuan untuk:`)
};

const da_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du vil modtage notifikationer for:`)
};

const de_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie erhalten Benachrichtigungen für:`)
};

const en_us2_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll receive notifications for:`)
};

const es_es2_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibirás notificaciones de:`)
};

const es_mx2_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibirás notificaciones para:`)
};

const fil_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makakatanggap ka ng mga notipikasyon para sa:`)
};

const fr_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous recevrez des notifications pour :`)
};

const it_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riceverai notifiche per:`)
};

const hu_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értesítéseket kapsz a következőkről:`)
};

const nl_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je ontvangt meldingen voor:`)
};

const no_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du vil motta varsler for:`)
};

const pl_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Będziesz otrzymywać powiadomienia dla:`)
};

const pt_br2_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll receive notifications for:`)
};

const pt_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receberá notificações para:`)
};

const ro_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vei primi notificări pentru:`)
};

const fi_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat ilmoituksia kohteesta:`)
};

const sv_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du får notiser för:`)
};

const vi_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn sẽ nhận thông báo cho:`)
};

const tr_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şunlar için bildirim alacaksınız:`)
};

const cs_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budete dostávat oznámení pro:`)
};

const bg_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ще получавате известия за:`)
};

const ru_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы будете получать уведомления для:`)
};

const uk_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви отримуватимете сповіщення для:`)
};

const ar_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ستتلقى إشعارات لـ:`)
};

const hi_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपको इसके लिए सूचनाएँ मिलेंगी:`)
};

const th_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณจะได้รับการแจ้งเตือนสำหรับ:`)
};

const ja_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以下の通知を受け取ります：`)
};

const zh_cn2_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll receive notifications for:`)
};

const zh_hant1_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll receive notifications for:`)
};

const ko_notifications_simple_youwillreceive2 = /** @type {(inputs: Notifications_Simple_Youwillreceive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll receive notifications for:`)
};

/**
* | output |
* | --- |
* | "You'll receive notifications for:" |
*
* @param {Notifications_Simple_Youwillreceive2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_simple_youwillreceive2 = /** @type {((inputs?: Notifications_Simple_Youwillreceive2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Simple_Youwillreceive2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_simple_youwillreceive2(inputs)
	if (locale === "ms") return ms_notifications_simple_youwillreceive2(inputs)
	if (locale === "da") return da_notifications_simple_youwillreceive2(inputs)
	if (locale === "de") return de_notifications_simple_youwillreceive2(inputs)
	if (locale === "en-US") return en_us2_notifications_simple_youwillreceive2(inputs)
	if (locale === "es-ES") return es_es2_notifications_simple_youwillreceive2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_simple_youwillreceive2(inputs)
	if (locale === "fil") return fil_notifications_simple_youwillreceive2(inputs)
	if (locale === "fr") return fr_notifications_simple_youwillreceive2(inputs)
	if (locale === "it") return it_notifications_simple_youwillreceive2(inputs)
	if (locale === "hu") return hu_notifications_simple_youwillreceive2(inputs)
	if (locale === "nl") return nl_notifications_simple_youwillreceive2(inputs)
	if (locale === "no") return no_notifications_simple_youwillreceive2(inputs)
	if (locale === "pl") return pl_notifications_simple_youwillreceive2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_simple_youwillreceive2(inputs)
	if (locale === "pt") return pt_notifications_simple_youwillreceive2(inputs)
	if (locale === "ro") return ro_notifications_simple_youwillreceive2(inputs)
	if (locale === "fi") return fi_notifications_simple_youwillreceive2(inputs)
	if (locale === "sv") return sv_notifications_simple_youwillreceive2(inputs)
	if (locale === "vi") return vi_notifications_simple_youwillreceive2(inputs)
	if (locale === "tr") return tr_notifications_simple_youwillreceive2(inputs)
	if (locale === "cs") return cs_notifications_simple_youwillreceive2(inputs)
	if (locale === "bg") return bg_notifications_simple_youwillreceive2(inputs)
	if (locale === "ru") return ru_notifications_simple_youwillreceive2(inputs)
	if (locale === "uk") return uk_notifications_simple_youwillreceive2(inputs)
	if (locale === "ar") return ar_notifications_simple_youwillreceive2(inputs)
	if (locale === "hi") return hi_notifications_simple_youwillreceive2(inputs)
	if (locale === "th") return th_notifications_simple_youwillreceive2(inputs)
	if (locale === "ja") return ja_notifications_simple_youwillreceive2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_simple_youwillreceive2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_simple_youwillreceive2(inputs)
	return ko_notifications_simple_youwillreceive2(inputs)
});
export { notifications_simple_youwillreceive2 as "notifications.simple.youWillReceive" }